import MyPageDesktopContainer from './MyPageDesktopContainer';
export default MyPageDesktopContainer;
